import { Button, Form, Input, message } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPage: React.FC = () => {
    const navigate = useNavigate();

    // useEffect(() => {
    //     localStorage.clear();
    // }, []);

    const onFinish = (values: { username: string; password: string }) => {
        // ── Tài khoản Admin ──────────────────────────────────────────────────
        if (values.username === "admin8amcoffee" && values.password === "admin123@") {
            localStorage.setItem('isAuthenticated8Am', 'true');
            localStorage.setItem('loginTime8Am', Date.now().toString());

            const redirectUrl = localStorage.getItem('redirectUrl') || '/coffee';
            localStorage.removeItem('redirectUrl');
            navigate(redirectUrl);
            return;
        }

        // ── Tài khoản nhân viên Cơ sở 2 ─────────────────────────────────────
        if (values.username === "nhanvien.cs2" && values.password === "cs2@8am2026") {
            localStorage.setItem('isBranch2Staff8Am', 'true');
            localStorage.setItem('branch2LoginTime8Am', Date.now().toString());
            navigate('/branch2-entry');
            return;
        }

        message.error('Sai tên đăng nhập hoặc mật khẩu');
    };

    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: '#f0f2f5'
        }}>
            <Form
                name="login"
                onFinish={onFinish}
                style={{
                    width: 300,
                    padding: 24,
                    borderRadius: 8,
                    background: 'white',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
            >
                <h1 style={{ textAlign: 'center', marginBottom: 24 }}>Đăng nhập</h1>
                <Form.Item
                    name="username"
                    rules={[{ required: true, message: 'Vui lòng nhập tên đăng nhập!' }]}
                >
                    <Input placeholder="Tên đăng nhập" />
                </Form.Item>
                <Form.Item
                    name="password"
                    rules={[{ required: true, message: 'Vui lòng nhập mật khẩu!' }]}
                >
                    <Input.Password placeholder="Mật khẩu" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" style={{ width: '100%' }}>
                        Đăng nhập
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default LoginPage;